<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div v-show="Isblur" class="splash"></div>

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="background-color:unset;">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
                <h2 style="font-size: 1.2vw !important"> ارکان اجرایی / {{ $route.params.title }} </h2>

                <div class="d-flex changer">
                  <p>
                    جدول
                  </p>
                  <router-link :to="`/executive_elements/chart/by/${$route.params.id}/${$route.params.title}`">
                    نمودار
                  </router-link>
                </div>
              </div>
              <center>
                <div class="alert alert-danger" style="width: 23vw;cursor: pointer;font-size:1vw;" v-if="modalMessage && all_items.length"
                     @click="modalMessageShowModal=true">برای مشاهده دلایل عدم تایید قبلی کلیک نمایید   
                </div>
                <div dir="rtl" class="modal__error slide-top" v-show="modalMessageShowModal"
                     style="z-index: 999999999999999; top: 40%;">
                  <div>
                    <p>دلایل عدم تایید</p>
                    <p @click="modalMessageShowModal=!modalMessageShowModal">❌</p>
                  </div>
                  <div>
                    <div class="bg-white w-100 rounded text-end p-2">
                      <p>{{ modalMessageShow }}</p>
                    </div>

                    <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
                      <button @click="modalMessageShowModal=false" class="btn btn-primary btn-back" type="submit">
                        برگشت
                      </button>
                    </div>
                  </div>
                </div>
              </center>

              <center v-show="status_show && all_items.length">
                <div class="alert alert-success">
                  تایید نهایی شرکت {{ $route.params.title }} انجام شد
                </div>
              </center>
              <div class="row" v-if="all_items.length">
                <div class="col-lg-4 mb-3">
                  <label class="form-label required">عنوان رکن اجرایی</label>
                  <input v-model="name" class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-4 mb-3">
                  <label class="form-label ">مافوق </label>
                  <v-select class="w-100" :options="all_items" dir="rtl" v-model="parent_item" label="name"
                            style="width: 12vw;   border-radius: .5vw">
                    <template v-slot:no-options>موردی یافت نشد</template>
                  </v-select>
                </div>
                <div class="col-lg-4 mb-3 d-flex">
                  <button v-if="!is_update" @click.prevent="submitForm" class="btn btn-primary btn-submit-1 mt-4">
                    افزودن
                  </button>
                  <button v-else @click.prevent="update(id_tem)" class="btn btn-primary btn-submit-1 mt-4">ویرایش
                  </button>
                  <Reset style="width: 1.3vw; height: 1.3vw; transform: translateY(1.7vw) translateX(-1vw)"
                         @click.prevent="resetForm" v-if="is_update"/>
                </div>
              </div>
              <hr class="mb-2">
              <div class="d-flex justify-content-between mb-2">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;"
                       placeholder="جستجو بر اساس نام ارکان...">

              </div>
            </div>
            <div class="table-responsive mt-3">
              <div v-show="!all_items.length">
                <center v-show="!all_items.length">
                  در انتظار تکمیل / بروزرسانی کاربرگ توسط {{ $route.params.title }}
                </center>
              </div>
              <div style="overflow-y: scroll; height: 50vw;" :style="filteredItems.length < 19 ? 'height: auto;' : ''">

                <table class="table table-striped" v-show="all_items.length">
                  <thead>
                  <tr>
                    <th style="width: 1vw;">ردیف</th>
                    <th>نام رکن</th>
                    <th>مافوق</th>
                    <th style="width: 10vw;"> اعضای کمیته</th>
                    <th style="width: 5vw;">عملیات</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in filteredItems" :style="setcolor(item['level'])">
                    <td scope="row">{{ index + 1 }}</td>

                    <td
                        style="text-align: right">{{ item['name'] }}
                    </td>
                    <td

                        style="text-align: right">
                      <span v-if="item.parent">{{ item.parent.name }}</span>
                      <span v-else>--</span>
                    </td>
                    <td>
                      <router-link :to="`/executive_elements/habits/${item.id}/${item.name}`"
                                   class="btn btn-submit-1 btn-primary w-100">تکمیل / بروزرسانی
                      </router-link>
                    </td>

                    <td>
                      <div class="d-flex justify-content-start align-items-start">


                        <a @click.prevent="edit(item['id'], item.name, item.parent)" href="#">
                          <img
                              class="table-edit-img"
                              src="../../../../assets/img/pen.svg"
                              alt="edit"></a>
                        <a class="mx-1" @click.prevent="deleteModalMethod(item['id'])" href="#">
                          <img
                              class="table-delete-img"
                              src="../../../../assets/img/delete.svg"
                              alt="delete"></a>
                      </div>
                    </td>
                  </tr>

                  </tbody>
                </table>

              </div>
              <div class="mt-3 d-flex align-items-center justify-content-center">

              </div>
              <div v-if="all_items.length" class="d-flex align-items-center justify-content-center mb-3">
                <a v-if="all_items.length"
                   style="margin-top: 1.2vw"
                   target="_blank"
                   :href="`${this.download_url}/ProductivityCommitteeMembers/${this.id_route}?token=${$cookies.get('id_login')}`"
                   class="btn btn-submit-1 btn-primary">خروجی کاربرگ 1</a>

                <a style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green "
                   class="btn btn-primary btn-submit-1 "

                   @click="acceptComplete"
                >
                  <div v-if="!status_loading">

                    <span>  تایید </span>
                  </div>
                  <div v-else>
                    <div class="loader-line"></div>

                  </div>
                </a>
                <a style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
                   class="btn btn-primary btn-submit-1 "
                   @click="acceptComplete2"
                >
                  <div v-if="!status_loading2">
                    <span>عدم تایید</span>
                  </div>

                  <div v-else>
                    <div class="loader-line"></div>

                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Jobs -->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="infoModal" style="z-index: 999999999999999">
    <div>
      <p>جزئیات</p>
      <p @click="infoModal=!infoModal">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; border-radius: 1vw; width: 28vw; padding: 1vw;">

      </div>

      <button @click="infoModal=!infoModal">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  /modals-->
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>

</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
import vSelect from "vue-select";

const toast = useToast();

export default {
  name: "ListOrganization",
  components: {vSelect, Reset, Sidebar, Splash},
  data() {
    return {
      id_route: this.$route['params']['id'],

      id: '',
      name: '',
      addModal: false,
      Isblur: false,
      deleteModal: false,
      select_parent: false,
      select_curator: false,
      select_substitute: false,
      id_remove: '',
      editModal: false,
      infoModal: false,
      Error: false,
      is_update: false,
      id_tem: false,
      ErrorM: '',
      searchUser: '',
      parent_item: '',
      all_items: [],
      status_show: false,
      status_loading: false,
      infoCancelled: false,
      text_info: '',
      modalMessageShow: '',
      modalMessage: false,
      modalMessageShowModal: false,
      status_loading2: false,

    }
  },
  methods: {


    edit(id, name, parent) {
      this.is_update = true
      this.id_tem = id
      this.name = name
      this.parent_item = parent
    },

    deleteModalMethod(id) {
      this.id = id
      this.deleteModal = true
    },
    acceptComplete() {
      if (this.status_show) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.status_show) {
          this.text_info = ''
          this.infoCancelled = true
          return;
        }
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ExecutiveElements/update/by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.infoCancelled = false
              this.fetchAll()

            }

          })
          .catch();
    },

    acceptComplete2() {

      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },

    acceptComplete3() {
      this.status_loading2 = true
      if (!this.status_show) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info) {
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/ExecutiveElements/update/by_mother/${this.id_route}`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ExecutiveElements/update/by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message) {
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading2 = false
              this.fetchAll()
            }
            this.infoCancelled = false

          })
          .catch();
    },

    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ExecutiveElements/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
            }
            this.deleteModal = false
            this.all_items.length = 0
            toast.success(result.data)
            this.fetchAll()

          })
          .catch();
    },
    setcolor(level) {

      if (level === 0) {
        return `background: #86D1FF !important`

      }


      if (level === 1) {
        return 'background: #bce6ff !important'

      }
      if (level === 2) {
        return 'background: #d9f1ff !important'

      } else {
        return 'background: rgba(#d9f1ff, 40%) !important'
      }


    },
    submitForm() {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'عنوان   اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/ExecutiveElements/by/store/${this.id_route}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'parent_item': this.parent_item && this.parent_item.code,


          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                this.Error = true
                this.ErrorM = response['error']
                this.loading = false
                return
              }
              toast.success(response.message)

              this.Isblur = false
              this.loading = false
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()


            }).catch((err) => {
        })


      }, 1000)
    },
    update(id) {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'عنوان   اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/ExecutiveElements/update/${id}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'parent_item': this.parent_item && this.parent_item.code,


          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                this.Error = true
                this.ErrorM = response['error']
                this.loading = false
                return
              }
              this.is_update = false
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()


            }).catch((err) => {
        })


      }, 1000)
    },
    resetForm() {
      this.name = ''
      this.is_update = false
      this.id = ''
      this.id_tem = ''
      this.parent_item = ''

    },


    fetchAll() {
      fetch(`${this.base_url}/ExecutiveElements/by/${this.id_route}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },


      })
          .then(response => response.json())
          .then((response) => {
            this.all_items.length=0
            if (response['error']) {
              return
            }
            if (response.all) {
              this.all_items = [...response.all]
            }

            if (response.status) {
              this.status_show = true
            }
            if (response.message) {
              this.modalMessage = true
              this.modalMessageShow = response.message
            }
            this.$store.commit('setExecutiveElement', true)

            if (response.message) {
              this.modalMessage = true
              this.modalMessageShow = response.message
            }


          }).catch((err) => {
      })
    },


    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.fetchAll()
  },
  computed: {
    filteredItems() {
      return this.all_items.filter(item => {
        return (
            item['name'] && item['name'].includes(this.searchUser)
        );
      });
    },


  },
}
</script>

<style scoped>
label {
  width: 100%;
  text-align: right;
}

table {
  background-color: white !important;
}


img {
  cursor: pointer;
}

tr {
  background-color: #ffff !important;
}

.changer {
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 10vw;
  margin-bottom: 2vw;
  justify-content: space-evenly;

  & > p:nth-child(1) {
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }

  & > p:nth-child(2) {
    margin-left: 1vw;
  }

  & > p {
    cursor: pointer;
    font-size: 1vw;
  }

  & > a {
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
</style>